import { render, staticRenderFns } from "./BillDetails.vue?vue&type=template&id=081f352c"
import script from "./BillDetails.vue?vue&type=script&lang=js"
export * from "./BillDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports